import * as React from "react";

// Navigate
// import { useNavigate } from "react-router-dom";

// CSS
import "@/styles/components/staffDetailCardStyles.css";

// Components
import { CurrencyFormat } from "@/config/normalConfig";

// Mui Styles
import { StyledDetailCard } from "@/styles/mui/globalStyles";

// Mui
import Typography from "@mui/material/Typography";

export default function StaffDetailCard(props) {
  // Navigate
  // const navigate = useNavigate();

  return (
    <StyledDetailCard onClick={props.onClick}>
      <div className="staffCardDetailContainer">
        <div className="profile">
          <Typography variant="h6" noWrap component="h6">
            {props.full_name
              ? props.full_name
              : props.work_name
              ? props.work_name
              : 0}
          </Typography>
          <Typography variant="p" noWrap component="p">
            {props.role_types_name}
          </Typography>
        </div>
        <div className="target">
          {props.area_manager && (
            <div>
              <Typography variant="caption" noWrap component="div">
                區域經理
              </Typography>
              <Typography
                variant="subtitle1"
                noWrap
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                {props.area_manager}
              </Typography>
            </div>
          )}
          {props.type !== "staff" && (
            <div>
              <Typography variant="caption" noWrap component="div">
                總目標金額
              </Typography>
              <Typography
                variant="subtitle1"
                noWrap
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                {CurrencyFormat(props.target_total ? props.target_total : 0)}
              </Typography>
            </div>
          )}
          <div>
            <Typography variant="caption" noWrap component="div">
              {props.type === "staff" ? "個人完成金額" : "總完成金額"}
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {CurrencyFormat(
                props.invoice_total
                  ? props.invoice_total
                  : props.shopInvoiceTotal
                  ? props.shopInvoiceTotal
                  : 0
              )}
            </Typography>
          </div>
        </div>
      </div>
    </StyledDetailCard>
  );
}
